const type = 'SET_SPLIT_INVOICE_SUBMITTING';

const setSplitInvoiceSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setSplitInvoiceSubmitting;
